import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "relative items-center py-4" }
const _hoisted_2 = { class: "flex items-center justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_field = _resolveComponent("input-field")!
  const _component_small_loader = _resolveComponent("small-loader")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_form_divider = _resolveComponent("form-divider")!
  const _component_form_wrapper = _resolveComponent("form-wrapper")!
  const _component_button_wrapper = _resolveComponent("button-wrapper")!
  const _component_modal_component = _resolveComponent("modal-component")!

  return (_openBlock(), _createBlock(_component_modal_component, {
    "is-displayed": _ctx.isEditModalOpened,
    "no-padding": true,
    title: "Edit node",
    onToggleModal: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('toggle-modal')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
      }, [
        _createVNode(_component_form_wrapper, { "is-form-in-modal": true }, {
          default: _withCtx(() => [
            _createVNode(_component_form_divider, null, {
              default: _withCtx(() => [
                _createVNode(_component_input_field, {
                  modelValue: _ctx.node.index,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.node.index) = $event)),
                  label: "Index"
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_1, [
                  _cache[8] || (_cache[8] = _createElementVNode("label", { class: "whitespace-nowrap text-sm font-medium not-italic text-gray-800" }, "Node type", -1)),
                  _createElementVNode("div", _hoisted_2, [
                    (_ctx.isNodeTypeListLoading)
                      ? (_openBlock(), _createBlock(_component_small_loader, {
                          key: 0,
                          height: "h-8",
                          width: "w-8"
                        }))
                      : (_openBlock(), _createBlock(_component_v_select, {
                          key: 1,
                          modelValue: _ctx.node.typeId,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.node.typeId) = $event)),
                          class: _normalizeClass(`mt-1 w-full border ${
                  _ctx.v$['node']?.typeId?.$error
                    ? 'rounded-md border-error'
                    : 'border-none'
                }`),
                          options: _ctx.nodeTypes,
                          reduce: (type) => type.id,
                          label: "name"
                        }, null, 8, ["modelValue", "class", "options", "reduce"]))
                  ])
                ]),
                _createVNode(_component_input_field, {
                  modelValue: _ctx.node.overrideValue,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.node.overrideValue) = $event)),
                  label: "Override value"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_input_field, {
                  modelValue: _ctx.node.correction,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.node.correction) = $event)),
                  label: "Correction"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_input_field, {
                  modelValue: _ctx.node.overrideFreeArrow,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.node.overrideFreeArrow) = $event)),
                  label: "Override free arrow"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_input_field, {
                  modelValue: _ctx.node.overrideOccupiedArrow,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.node.overrideOccupiedArrow) = $event)),
                  label: "Override occupied arrow"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_button_wrapper, { "is-submit-loading": _ctx.isSubmitLoading }, null, 8, ["is-submit-loading"])
      ], 32)
    ]),
    _: 1
  }, 8, ["is-displayed"]))
}